import {X, Scroll} from "lucide-react";

export const VoicemailTranscriptModal = ({isOpen, onClose, transcription}) => {
  if (!isOpen) return null;

  console.log("Transcripts:", JSON.stringify(transcription));

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
      <div className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl flex flex-col max-h-[85vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-[#2ba9cd]/10 rounded-lg text-[#2ba9cd]">
              <Scroll size={20} />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-slate-900">
                Transcript
              </h3>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full"
          >
            <X size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-gray-100">
          <div className={`px-4 py-2.5 rounded-2xl text-gray-500`}>
            {transcription}
          </div>
        </div>
      </div>
    </div>
  );
};
